import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES, MODULE_TABS, MODULE_LABELS, SCHUTZBEDARFSANALYSE_MODULES } from '../../config/constants';
import SchutzbedarfsanalyseHeader from './components/SchutzbedarfsanalyseHeader/SchutzbedarfsanalyseHeader';
import SchutzbedarfsanalyseSubNav from './components/SchutzbedarfsanalyseSubNav/SchutzbedarfsanalyseSubNav';
import ProzesseSection from './components/sections/ProzesseSection/ProzesseSection';
import AnwendungenSection from './components/sections/AnwendungenSection/AnwendungenSection';
import AnalysenSection from './components/sections/AnalysenSection/AnalysenSection';
import RisikenSection from './components/sections/RisikenSection/RisikenSection';
import MassnahmenSection from './components/sections/RisikenSection/MassnahmenSection';
import GapAnalyseSection from './components/sections/GapAnalysenSection/GapAnalyseSection';
import './SchutzbedarfsanalysePage.css';
import './schutzbedarfsanalyse-global-theme.css';

const SchutzbedarfsanalysePage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [currentModule, setCurrentModule] = useState(
        location.state?.module || SCHUTZBEDARFSANALYSE_MODULES.INFORMATIONSSICHERHEIT
    );

    const [selectedAnalyse, setSelectedAnalyse] = useState(null);
    const [activeSection, setActiveSection] = useState('prozesse');

    const availableTabs = MODULE_TABS[currentModule] || [];

    useEffect(() => {
    }, [selectedAnalyse]);

    useEffect(() => {
        const path = location.pathname;

        if (location.state?.module) {
            setCurrentModule(location.state.module);
        }

        // Detect active section from path
        if (path.includes('/gap-analysen')) {
            setActiveSection('gap-analysen');
        } else if (path.includes('/massnahmen')) {
            setActiveSection('massnahmen');
        } else if (path.includes('/analysen')) {
            setActiveSection('analysen');
        } else if (path.includes('/risiken')) {
            setActiveSection('risiken');
        } else if (path.includes('/anwendungen')) {
            setActiveSection('anwendungen');
        } else {
            setActiveSection('prozesse');
        }

        const pathSection = path.includes('/gap-analysen') ? 'gap-analysen'
            : path.includes('/massnahmen') ? 'massnahmen'
                : path.includes('/analysen') ? 'analysen'
                    : path.includes('/risiken') ? 'risiken'
                        : path.includes('/anwendungen') ? 'anwendungen'
                            : 'prozesse';

        if (!availableTabs.includes(pathSection)) {
            const firstTab = availableTabs[0];
            const routes = {
                'prozesse': ROUTES.SCHUTZBEDARFSANALYSE_PROZESSE,
                'anwendungen': ROUTES.SCHUTZBEDARFSANALYSE_ANWENDUNGEN,
                'analysen': ROUTES.SCHUTZBEDARFSANALYSE_ANALYSEN,
                'gap-analysen': ROUTES.SCHUTZBEDARFSANALYSE_GAP_ANALYSEN,
                'risiken': ROUTES.SCHUTZBEDARFSANALYSE_RISIKEN,
                'massnahmen': ROUTES.SCHUTZBEDARFSANALYSE_MASSNAHMEN,
            };
            navigate(routes[firstTab], { replace: true, state: { module: currentModule } });
        }
    }, [location.pathname, location.state, currentModule, availableTabs, navigate]);

    const handleSectionChange = (section) => {
        if (!availableTabs.includes(section)) {
            alert(`Dieser Tab ist im ${MODULE_LABELS[currentModule]}-Modul nicht verfügbar`);
            return;
        }

        setActiveSection(section);

        const routes = {
            'prozesse': ROUTES.SCHUTZBEDARFSANALYSE_PROZESSE,
            'anwendungen': ROUTES.SCHUTZBEDARFSANALYSE_ANWENDUNGEN,
            'analysen': ROUTES.SCHUTZBEDARFSANALYSE_ANALYSEN,
            'gap-analysen': ROUTES.SCHUTZBEDARFSANALYSE_GAP_ANALYSEN,
            'risiken': ROUTES.SCHUTZBEDARFSANALYSE_RISIKEN,
            'massnahmen': ROUTES.SCHUTZBEDARFSANALYSE_MASSNAHMEN,
        };

        navigate(routes[section], { state: { module: currentModule } });
    };

    const handleAnalyseSelect = (analyse) => {
        setSelectedAnalyse(analyse);
    };

    return (
        <div className="schutzbedarfsanalyse-page">
            <SchutzbedarfsanalyseHeader
                currentModule={currentModule}
                moduleLabel={MODULE_LABELS[currentModule]}
            />
            <SchutzbedarfsanalyseSubNav
                activeSection={activeSection}
                onSectionChange={handleSectionChange}
                availableTabs={availableTabs}
            />

            <div className="schutzbedarfsanalyse-content">
                {activeSection === 'prozesse' && availableTabs.includes('prozesse') && (
                    <ProzesseSection />
                )}

                {activeSection === 'anwendungen' && availableTabs.includes('anwendungen') && (
                    <AnwendungenSection />
                )}

                {activeSection === 'analysen' && availableTabs.includes('analysen') && (
                    <AnalysenSection
                        onAnalyseSelect={handleAnalyseSelect}
                        selectedAnalyse={selectedAnalyse}
                    />
                )}

                {activeSection === 'gap-analysen' && availableTabs.includes('gap-analysen') && (
                    <GapAnalyseSection />
                )}

                {activeSection === 'risiken' && availableTabs.includes('risiken') && (
                    <RisikenSection
                        selectedAnalyse={selectedAnalyse}
                        onAnalyseSelect={handleAnalyseSelect}
                    />
                )}

                {activeSection === 'massnahmen' && availableTabs.includes('massnahmen') && (
                    <MassnahmenSection />
                )}
            </div>
        </div>
    );
};

export default SchutzbedarfsanalysePage;
